import { action } from 'satcheljs';

export const closeNPSFormAction = action('CLOSE_NPS_FORM');
